<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Looking for Players" subtitle="See which games are looking for a player right now.">

		<app-content-head-actions-item text="Look" :loading="is.saving" :success="true" icon="event.live.looking" v-on:click="onLookClick" v-if="canFlag" />
		<app-content-head-actions-item text="Stop" :loading="is.deleting" :danger="true" icon="event.live.notlooking" v-on:click="onLookClick" v-if="canUnflag" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" :is-grid="2" :is-empty="!collection.length" placeholder="No games found.">

		<div class="looking-item" v-tooltip="(item.event) ? 'Click to view event page' : false" :class="{'can-click': item.event}" v-for="item in collection" :key="item.id" v-on:click="onClick(item)">
			<div class="looking-item-text">{{ item.name }}</div>
			<div class="looking-item-location">{{ item.location }}</div>
			<div class="looking-item-date">{{ item.date | fromNow }}</div>
		</div>

	</app-content-body>
    
	<com-looking v-if="is.looking" v-on:close="is.looking = false" />

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'
import comLooking from './common/panel/Looking'

export default {

	mixins: [mixCollection],

    components: {
        'com-looking': comLooking
    },

	data: function() {

		return {
			pagination: false,
			inline: true,
			endpoint: 'convention/looking',
			references: {
				looking: false,
				active: false
			},
			is: {
				looking: false,
				deleting: false,
				saving: false
			}
		}

	},

    created: function() {

		this.$live.$on('convention/looking', this.onActivity.bind(this))

	},

	beforeDestroy: function() {

		this.$live.$off('convention/looking', this.onActivity.bind(this))

	},

	computed: {
	
		canFlag: function() {
		
			return !this.references.looking
		
		},
	
		canUnflag: function() {
		
			return this.references.looking
		
		}

	},

	methods: {

        onClick: function(item) {

            if(!item.event) return false
        
            this.$router.push({
                name: 'Convention.Schedule.Event',
                params: {
                    id: item.event
                }
            })

        },

		onLookClick: function() {

			if (this.canFlag) {

				if (this.references.active) {
			
					this.is.saving = true

					this.$api.patch('convention/looking').then(function() {
					
						this.is.saving = false
					
					}.bind(this))
				
				} else {
		
					this.is.looking = true
				
				}
			
			} else if (this.canUnflag) {

				this.is.deleting = true
			
				this.$api.delete('convention/looking').then(function() {
				
					this.is.deleting = false
					this.references.looking = false
				
				}.bind(this))
			
			}

		},

		onActivity: function() {

			this.loadRefresh()

		}

	}

}

</script>

<style scoped>

.looking-item {
    padding: 10px;
    border: 1px solid #eee;
	border-radius: 4px;
	background-color: #fff;
    padding-right: 150px;
}

.looking-item.can-click {
    cursor: pointer;
}

.looking-item-text {
    font-size: 24px;
    font-weight: 500;
}

.is-mobile .looking-item-text {
	font-size: 20px;
}

.looking-item-location {
    font-size: 14px;
    font-weight: 400;
    margin-top: 2px;
    color: #687589;
}

.looking-item-date {
    font-size: 16px;
    color: #687589;
    font-weight: 700;
    color: #4082d3;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

.is-mobile .looking-item-date {
	position: relative;
	transform: none;
	text-align: right;
	right: auto;
	top: 0px;
	font-size: 12px;
	margin-top: 10px;
}

</style>